import axios from '@axios'

/**
 * ÍNDICE
 * 
 * {@link getProviders} - Obtener clientes
 * {@link getProvider} - Obtener cliente
 * {@link addProvider} - Añadir cliente 
 * {@link updateProvider} - Actualizar cliente 
 * {@link deleteProvider} - Eliminar cliente 
 */


    /**
     * Obtener todos los clientes
     * @param {*} data Datos para filtrar la consulta
     * @returns clients  | error
     */
    export const getProviders = function(queryParams)  {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/providers', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }

    /**
     * 
     * @param {integer} id ID del cliente 
     * @returns client
     */
    export const getProvider = function (id) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/providers/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
    }

    /**
     * 
     * @param {*} data Datos del cliente 
     * @returns 
     */
    export const addProvider = function (data) {

        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/providers`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }  
    }

    /**
     * 
     * @param {integer} id ID del cliente a borrar 
     * @returns 
     */
    export const deleteProvider = function ( { id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/providers/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }

    /**
     * 
     * @param {*} data Datos del cliente a actualizar 
     * @returns 
     */
    export const updateProvider = function (data, id) {
        try {

            return new Promise((resolve, reject) => {
                axios
                    .put(`/providers/${data}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        } catch (error) {
            return error
        }
        }
    
